var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slc-shortcuts',{attrs:{"items":_vm.items},on:{"click-shortcut":_vm.selectShortcut}})}
var staticRenderFns = []

export { render, staticRenderFns }